export const begin = "begin";
export const complete = "complete";



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/alme-notificationsapi/src/actions/actionStatuses.js